export const getEntityIconName = (entityKind: string): string => {
    switch (entityKind) {
        case "CLIENT":
            return "07_ClientInfo";
        case "COMMUNITY":
            return "57_Community";
        case "REFERENCECONTACT":
            return "40_ReferralPerson";
        case "REFERENCEBUSINESS":
            return "39_Business";
        default:
            return "07_ClientInfo"; // Default fallback
    }
};
